const itemTypes = {
  VULN: 'VULN'
};

export default itemTypes;
